import React, { useState, useContext } from 'react';
import styles from './ChatHeader.module.sass';
import 'react-sliding-side-panel/lib/index.css';
import UserPhoto from '../../../components/UserPhoto';
import { ChatContext } from "../../../contexts/ChatContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UserContext } from '../../../contexts/UserContext';
import cn from 'classnames'
import CallIcon from '@mui/icons-material/Call';
import { IconButton } from '@mui/material';

const ChatHeader = ({onBackCallback}) => {

    const userContext = useContext( UserContext );
    const chatContext = useContext( ChatContext );
    const connectedFriends = Object.values( chatContext.avatars );

    let currentUser = chatContext.getTargetAvatar();

    // if( !chatContext.roomInstance.isGroup ) return <></>;

    return (
        <div className={cn(styles.container, chatContext.roomInstance.isGroup && styles.group)}>
            <div className={styles.container__left}>
                {onBackCallback && <button className={cn('button small', styles.backButton)} onClick={onBackCallback}><ArrowBackIcon /></button>}
                {
                    ( !chatContext.roomInstance.isGroup ? 
                        <>
                            <div className={styles.avatar}>
                                <UserPhoto data={currentUser} fallbackToMe={false}/>
                                <span className={styles.name}>
                                    {currentUser.firstName}
                                </span>
                            </div>
                            { chatContext.isPersistent && <IconButton className={styles.chatAction} aria-label='send' onClick={() => { chatContext.peer.startCall() }}>
                                <CallIcon
                                    className={styles.container__inputRight__send}
                                />
                            </IconButton>}
                        </>
                    :
                    <p>Users Online {connectedFriends.length}</p>
                    )
                }
            </div>
        </div>
    );
};

export default ChatHeader;
